import {
  get,
  post, //, remove
} from 'src/tools/server';

const getTags = (startIndex, pageSize, body) => {
  return post(`/portal/customer/tags/${startIndex}/${pageSize}`, body, {});
};
const getTag = (uuid: string) => {
  return get(`/portal/customer/tag/${uuid}`, {});
};
const postTag = (body) => {
  return post(`/portal/customer/tag`, body, {
    returnWholeData: true,
    handleErrorAsResolve: true,
  });
};
const deleteTags = (customerTagUuids) => {
  return post(`/portal/customer/tags/delete`, customerTagUuids, {});
};
export { getTags, getTag, postTag, deleteTags };
